import React from 'react';
import { Cake, GraduationCap, Camera, HeartHandshake } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
interface EventsProps {
  onNavigate: (page: 'home' | 'rental') => void;
}
export function Events({
  onNavigate
}: EventsProps) {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const events = [{
    id: 1,
    title: 'Geburtstage',
    icon: Cake,
    desc: 'Feiere deinen Geburtstag mit deinen Liebsten im Studio.',
    price: 'Ab 150 €',
    color: 'bg-peony-100 text-peony-600'
  }, {
    id: 2,
    title: 'Workshops',
    icon: GraduationCap,
    desc: 'Exklusive Workshops mit Top-Trainern.',
    price: 'Auf Anfrage',
    color: 'bg-purple-100 text-purple-600'
  }, {
    id: 3,
    title: 'Fotoshootings',
    icon: Camera,
    desc: 'Professionelle Fitness-Fotoshootings im Studio.',
    price: 'Ab 80 €',
    color: 'bg-teal-100 text-teal-600'
  }, {
    id: 4,
    title: 'JGA',
    icon: HeartHandshake,
    desc: 'Unvergesslicher Junggesellinnenabschied mit Fitness-Fun.',
    price: 'Ab 200 €',
    color: 'bg-orange-100 text-orange-600'
  }];
  return <section id="events" className="py-24 bg-white" data-id="element-42">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <div className="text-center mb-16" data-id="element-44">
          <h2 className="text-4xl md:text-5xl font-bold text-dark-studio mb-4" data-id="element-45">
            Events & Raumvermietung
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-46">
            Unser Studio ist mehr als nur ein Trainingsort. Miete unsere
            Räumlichkeiten für dein besonderes Event.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-47">
          {events.map((event, index) => <div key={event.id} className={`flip-card h-80 w-full cursor-pointer ${isVisible ? 'animate-fade-in-up' : 'opacity-0'}`} style={{
          animationDelay: `${index * 150}ms`
        }} data-id="element-48">
              <div className="flip-card-inner rounded-2xl shadow-xl" data-id="element-49">
                <div className="flip-card-front bg-white rounded-2xl flex flex-col items-center justify-center p-6 border border-gray-100" data-id="element-50">
                  <div className={`w-20 h-20 rounded-full flex items-center justify-center mb-6 ${event.color}`} data-id="element-51">
                    <event.icon size={40} data-id="element-52" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800" data-id="element-53">
                    {event.title}
                  </h3>
                  <p className="text-gray-400 mt-2 text-sm" data-id="element-54">Dreh mich um!</p>
                </div>
                <div className="flip-card-back bg-gradient-to-br from-dark-studio to-dark-deep text-white rounded-2xl flex flex-col items-center justify-center p-6" data-id="element-55">
                  <h3 className="text-xl font-bold mb-4 text-peony-300" data-id="element-56">
                    {event.title}
                  </h3>
                  <p className="text-gray-300 mb-6 text-center leading-relaxed" data-id="element-57">
                    {event.desc}
                  </p>
                  <div className="bg-white/10 px-4 py-2 rounded-lg mb-4 backdrop-blur-sm" data-id="element-58">
                    <span className="font-bold text-white" data-id="element-59">{event.price}</span>
                  </div>
                  <button onClick={() => onNavigate('rental')} className="text-sm font-bold text-peony-300 hover:text-white transition-colors uppercase tracking-wide" data-id="element-60">
                    Mehr erfahren →
                  </button>
                </div>
              </div>
            </div>)}
        </div>

        {/* CTA to rental page */}
        <div className="text-center mt-12" data-id="element-61">
          <button onClick={() => onNavigate('rental')} className="btn-primary" data-id="element-62">
            Alle Mietoptionen ansehen
          </button>
        </div>
      </div>
    </section>;
}